import styled from 'styled-components';
import { Button, TextBlock } from 'bench-internal-theme';
import { colors } from 'bench-style-constants';

export const LedgerNavigationLayout = styled.div`
  display: grid;
  grid-template-rows: 64px auto min-content;
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
`;

export const LedgerNavigationHeader = styled(TextBlock).attrs(() => ({ styleType: 'title' }))`
  padding: 16px;
`;

export const LedgerNavigationLinks = styled.div`
  overflow: auto;
`;

export const LedgerNameWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

export const EntryCount = styled.span`
  padding: 4px 8px;
  margin: 0px 4px;
  background: ${colors.stone};
  color: ${colors.white};
  border-radius: 4px;
`;

type LedgerNavigationLinkProps = {
  // The index in the generalLedgerListItemData array
  index: number;
  // The bound scrollToItem function from GeneralLedger
  scrollToItem: (index: number) => any;
};

export const LedgerNavigationLink = styled(Button).attrs(
  ({ index, scrollToItem }: LedgerNavigationLinkProps) => ({
    'data-heap-id': 'general-ledger-ledger-navigation-link',
    styleType: 'total-ghost',
    size: 'large',
    onClick: () => scrollToItem(index),
  }),
)`
  color: ${colors.ash};
  justify-content: left;
  line-height: 20px;
  padding: 0 24px;
  text-transform: none;
  width: 100%;
  white-space: normal;
  text-align: left;

  ${({ isCurrent }) =>
    isCurrent &&
    `
        color: ${colors.charcoal};
        font-weight: 600;
        background-color: #f0f8f8
      `};
`;

type LedgerNavigationHeaderProps = {
  // The index in the generalLedgerListItemData array
  index: number;
  // The bound scrollToItem function from GeneralLedger
  scrollToItem: (index: number) => any;
};

export const LedgerNavigationCategoryHeader = styled(Button).attrs(
  ({ index, scrollToItem }: LedgerNavigationHeaderProps) => ({
    'data-heap-id': 'general-ledger-ledger-navigation-link',
    styleType: 'total-ghost',
    size: 'large',
    onClick: () => scrollToItem(index),
  }),
)`
  color: ${colors.charcoal};
  font-weight: 600;
  justify-content: left;
  margin-top: 16px;
  padding: 0 24px;
  width: 100%;

  ${({ isCurrent }) =>
    isCurrent &&
    `
        font-weight: 700;
        background-color: #f0f8f8
      `};
`;
